import axios from 'axios';
import React, { useEffect, useReducer, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import FileForm from './FileForm';
import FileUploader from './FileUploader';
import get from 'lodash.get';
import imagesReducer from './imagesReducer';
import * as yup from 'yup';
import useError from '../../../../hooks/useError';
import Loader from '../../../Loader';

// VALIDATION SCHEMA

const schema = yup.array().of(
      yup.object().shape({
        _id: yup.number().required(),
        src: yup.string().required(),
        alt: yup.string().required(),
        width: yup.number().required().positive().integer(),
        height: yup.number().required().positive().integer(),
        order: yup.number().required().min(0).integer(),
      })
    )
    .required();

const ImageForm = () => {
  const history = useHistory();
  const handleError = useError();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [sent, setSent] = useState(0);
  const [state, dispatch] = useReducer(imagesReducer, {});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`/api/projects/${params.id}`);
        dispatch({ type: 'init', payload: { 
          images: get(data, 'images', []),
        }});
        setLoading(false);
      } catch (error) {
        handleError(error);
      }
    };
    fetchData();
  }, [params.id]);

  // SUBMIT FUNCTION

  const handleSubmit = async (e) => {
    e.preventDefault();

    // VALIDATION
    const formIsValid = await schema.isValid(state.images);
    setSent((sent) => sent++);

    if (formIsValid && state.images.length > 0) {
      setLoading(true);
      try {
        await axios.put(
          `/api/projects/${params.id}/images`,
          {
            project: {
              images: state.images, 
            },
          },
          {
            withCredentials: true,
          }
        );
        setLoading(false);
        // Redirect to dashboard
        history.push('/admin/dashboard');
      } catch (error) {
        handleError(error);
      }
    }
  };

  if (loading) {
    return (
      <div className='container main-page flex'>
        <Loader />
      </div>
    );
  }

  return (
    <div className='container content main-page'>
      <div className='flex'>
        <form onSubmit={handleSubmit}>
          <div className='grid images-grid'>
            {state.images.length > 0 &&
              state.images
                .sort((a, b) => a.order - b.order)    // array should be already sorted, but Justin Case
                .map((image) => {
                  return (
                    <FileForm
                      key={image._id}
                      image={image}
                      length={state.images.length}
                      dispatch={dispatch}
                      projectId={params.id}
                      sent={sent}
                    />
                  );
                })}
          </div>

          <FileUploader
            projectId={params.id}
            addImage={(payload) => dispatch({ type: 'add', payload })}
          />

          <div className='flex pt-small space-around image-form-buttons'>
            <button
              className='montserrat button'
              onClick={() => history.push(`/admin/editProject/${params.id}`)}
            >
              Indietro
            </button>
            <button
              className='montserrat button'
              type='submit'
              disabled={state.images.length < 1}
            >
              Salva
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImageForm;
